import Breadcrumbs from "@/components/common/sections/Breadcrumbs";
import BreadcrumbsImage from "@/assets/images/breadcrumbs/Nas-breadcrumbs.webp";

export default function AISolutionsPage() {
	return (
		<>
			<Breadcrumbs
				title="NAS"
				subtitle=""
				breadcrumbText="NAS"
				backgroundImage={BreadcrumbsImage}
			/>
		</>
	);
}